import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ClienteLayout from '../../components/ClienteLayout'
import {
  getMisPerfilesFacturacion,
  crearPerfilFacturacion,
  actualizarPerfilFacturacion,
  eliminarPerfilFacturacion,
  setDefaultPerfilFacturacion,
} from '../../lib/perfilesFacturacionApi'
import { validarRutUY, limpiarRut, formatearRut } from '../../lib/rutUY'

const EMPTY_FORM = {
  tipo: 'empresa',
  alias: '',
  razonSocial: '',
  rut: '',
  direccionFiscal: '',
  telefonoFiscal: '',
  emailFiscal: '',
  esDefault: false,
}

export default function Facturacion() {
  const [perfiles, setPerfiles] = useState([])
  const [cargando, setCargando] = useState(true)
  const [editandoId, setEditandoId] = useState(null)  // null | id | 'nuevo'
  const [form, setForm] = useState(EMPTY_FORM)
  const [guardando, setGuardando] = useState(false)
  const [err, setErr] = useState(null)
  const [msg, setMsg] = useState(null)

  useEffect(() => { cargar() }, [])

  async function cargar() {
    setCargando(true)
    const list = await getMisPerfilesFacturacion()
    setPerfiles(list)
    setCargando(false)
  }

  function abrirNuevo() {
    setForm({ ...EMPTY_FORM, esDefault: perfiles.length === 0 })
    setEditandoId('nuevo')
    setErr(null)
  }

  function abrirEditar(p) {
    setForm({
      tipo: p.tipo,
      alias: p.alias || '',
      razonSocial: p.razon_social || '',
      rut: p.rut || '',
      direccionFiscal: p.direccion_fiscal || '',
      telefonoFiscal: p.telefono_fiscal || '',
      emailFiscal: p.email_fiscal || '',
      esDefault: !!p.es_default,
    })
    setEditandoId(p.id)
    setErr(null)
  }

  function cancelar() {
    setEditandoId(null)
    setForm(EMPTY_FORM)
    setErr(null)
  }

  async function guardar(e) {
    e?.preventDefault()
    setErr(null)
    if (!form.alias.trim()) { setErr('Poné un alias (ej: "Personal" o "Mi SAS")'); return }
    if (form.tipo === 'empresa') {
      if (!form.razonSocial.trim()) { setErr('Falta razón social'); return }
      if (!validarRutUY(form.rut)) { setErr('RUT inválido (12 dígitos)'); return }
    }
    setGuardando(true)
    try {
      if (editandoId === 'nuevo') {
        await crearPerfilFacturacion({ ...form, rut: limpiarRut(form.rut) })
        setMsg('Perfil creado.')
      } else {
        await actualizarPerfilFacturacion(editandoId, { ...form, rut: limpiarRut(form.rut) })
        setMsg('Perfil actualizado.')
      }
      await cargar()
      cancelar()
      setTimeout(() => setMsg(null), 2500)
    } catch (e2) {
      setErr(e2?.message || String(e2))
    }
    setGuardando(false)
  }

  async function eliminar(p) {
    if (!confirm(`¿Eliminar "${p.alias}"?`)) return
    try {
      await eliminarPerfilFacturacion(p.id)
      await cargar()
      setMsg('Perfil eliminado.')
      setTimeout(() => setMsg(null), 2500)
    } catch (e) {
      alert(e?.message || 'No se pudo eliminar')
    }
  }

  async function marcarDefault(p) {
    try {
      await setDefaultPerfilFacturacion(p.id)
      await cargar()
    } catch (e) {
      alert(e?.message || 'No se pudo marcar default')
    }
  }

  return (
    <ClienteLayout title="Datos de facturación">
      <div className="fc-wrap">
        <div className="fc-header">
          <Link to="/cliente/cuenta" className="fc-back">← Mi cuenta</Link>
          <h1 className="fc-h1">Datos de facturación</h1>
          <p className="fc-sub">
            Cargá tu RUT si querés que te facturemos como empresa. Al comprar elegís
            con qué perfil va cada pedido (personal o empresa).
          </p>
        </div>

        {msg && <div className="fc-toast">{msg}</div>}

        {/* Lista de perfiles */}
        {cargando ? (
          <div className="fc-loading">Cargando…</div>
        ) : (
          <>
            <div className="fc-list">
              {perfiles.length === 0 && (
                <div className="fc-empty">
                  Todavía no cargaste ningún perfil. Por ahora te facturamos como <strong>consumidor final</strong>.
                </div>
              )}

              {perfiles.map(p => (
                <div key={p.id} className={`fc-card ${p.es_default ? 'is-default' : ''}`}>
                  <div className="fc-card-h">
                    <div className="fc-card-l">
                      <span className={`fc-tipo-pill ${p.tipo}`}>
                        {p.tipo === 'empresa' ? '🏢 Empresa' : '👤 Consumidor final'}
                      </span>
                      {p.es_default && <span className="fc-default-pill">★ Default</span>}
                    </div>
                    <div className="fc-card-actions">
                      {!p.es_default && (
                        <button type="button" onClick={() => marcarDefault(p)} className="fc-action-btn">
                          Marcar default
                        </button>
                      )}
                      <button type="button" onClick={() => abrirEditar(p)} className="fc-action-btn">
                        Editar
                      </button>
                      <button type="button" onClick={() => eliminar(p)} className="fc-action-btn danger">
                        Eliminar
                      </button>
                    </div>
                  </div>
                  <div className="fc-card-alias">{p.alias}</div>
                  {p.tipo === 'empresa' && (
                    <>
                      <div className="fc-card-line"><span>Razón social:</span> {p.razon_social}</div>
                      <div className="fc-card-line"><span>RUT:</span> {formatearRut(p.rut)}</div>
                      {p.direccion_fiscal && <div className="fc-card-line"><span>Domicilio fiscal:</span> {p.direccion_fiscal}</div>}
                      {p.email_fiscal && <div className="fc-card-line"><span>Email facturación:</span> {p.email_fiscal}</div>}
                      {p.telefono_fiscal && <div className="fc-card-line"><span>Teléfono:</span> {p.telefono_fiscal}</div>}
                    </>
                  )}
                </div>
              ))}
            </div>

            {/* Botón agregar */}
            {!editandoId && (
              <button type="button" onClick={abrirNuevo} className="fc-btn-add">
                + Agregar perfil de facturación
              </button>
            )}
          </>
        )}

        {/* Form de alta/edición */}
        {editandoId && (
          <form className="fc-form" onSubmit={guardar}>
            <h2 className="fc-form-h">{editandoId === 'nuevo' ? 'Nuevo perfil' : 'Editar perfil'}</h2>

            {editandoId === 'nuevo' && (
              <Field label="Tipo" required>
                <select value={form.tipo} onChange={e => setForm(f => ({ ...f, tipo: e.target.value }))}>
                  <option value="empresa">Empresa (con RUT)</option>
                  <option value="consumidor_final">Consumidor final</option>
                </select>
              </Field>
            )}

            <Field label="Alias" required hint="Cómo querés llamarlo (ej: 'Personal', 'Mi SAS')">
              <input type="text" value={form.alias}
                     onChange={e => setForm(f => ({ ...f, alias: e.target.value }))}
                     placeholder={form.tipo === 'empresa' ? 'Mi empresa SAS' : 'Personal'}
                     maxLength={60} required />
            </Field>

            {form.tipo === 'empresa' && (
              <>
                <Field label="Razón social" required>
                  <input type="text" value={form.razonSocial}
                         onChange={e => setForm(f => ({ ...f, razonSocial: e.target.value }))}
                         placeholder="Ej: Mi Empresa SAS"
                         maxLength={120} required />
                </Field>

                <Field label="RUT" required hint="12 dígitos. Lo validamos al guardar.">
                  <input type="text" value={form.rut}
                         onChange={e => setForm(f => ({ ...f, rut: e.target.value }))}
                         placeholder="21.234.567.890-3"
                         inputMode="numeric"
                         maxLength={20} required />
                </Field>

                <Field label="Domicilio fiscal" hint="Aparece en la factura. No afecta el envío.">
                  <input type="text" value={form.direccionFiscal}
                         onChange={e => setForm(f => ({ ...f, direccionFiscal: e.target.value }))}
                         placeholder="Av. Italia 1234, Montevideo" />
                </Field>

                <div className="fc-row-2">
                  <Field label="Email facturación" hint="A dónde mandamos las facturas">
                    <input type="email" value={form.emailFiscal}
                           onChange={e => setForm(f => ({ ...f, emailFiscal: e.target.value }))}
                           placeholder="facturacion@miempresa.uy" />
                  </Field>
                  <Field label="Teléfono">
                    <input type="tel" value={form.telefonoFiscal}
                           onChange={e => setForm(f => ({ ...f, telefonoFiscal: e.target.value }))}
                           placeholder="+598 99 123 456" />
                  </Field>
                </div>
              </>
            )}

            <label className="fc-check">
              <input type="checkbox" checked={form.esDefault}
                     onChange={e => setForm(f => ({ ...f, esDefault: e.target.checked }))} />
              <span>Marcar como default (se usa cuando no elegís otro al comprar)</span>
            </label>

            {err && <div className="fc-err">{err}</div>}

            <div className="fc-form-actions">
              <button type="button" className="fc-btn-secondary" onClick={cancelar}>Cancelar</button>
              <button type="submit" className="fc-btn-primary" disabled={guardando}>
                {guardando ? 'Guardando…' : 'Guardar'}
              </button>
            </div>
          </form>
        )}
      </div>

      <style>{css}</style>
    </ClienteLayout>
  )
}

function Field({ label, required, hint, children }) {
  return (
    <label className="fc-field">
      <span className="fc-field-l">{label}{required && <em>*</em>}</span>
      {children}
      {hint && <span className="fc-field-hint">{hint}</span>}
    </label>
  )
}

const css = `
.fc-wrap { max-width: 760px; margin: 0 auto; padding: 16px 16px 32px }
.fc-loading { padding: 40px; text-align: center; color: var(--cl-muted) }
.fc-header { margin-bottom: 16px }
.fc-back { font-size: 13px; color: var(--cl-muted); text-decoration: none; font-weight: 700 }
.fc-back:hover { color: var(--cl-text) }
.fc-h1 { font-size: 24px; font-weight: 900; color: var(--cl-text); margin: 8px 0 4px; letter-spacing: -.02em }
.fc-sub { font-size: 13px; color: var(--cl-muted); line-height: 1.5 }

.fc-toast {
  background: #ecfdf5; border: 1px solid #86efac; color: #065f46;
  padding: 10px 14px; border-radius: 10px; font-size: 13px; font-weight: 700;
  margin-bottom: 14px;
}

.fc-empty {
  padding: 16px; text-align: center; background: rgba(0,0,0,.15);
  border: 1px dashed var(--cl-line); border-radius: 12px;
  font-size: 13px; color: var(--cl-muted);
}

.fc-list { display: flex; flex-direction: column; gap: 12px; margin-bottom: 14px }
.fc-card {
  background: var(--cl-card); border: 1.5px solid var(--cl-line); border-radius: 14px;
  padding: 14px 16px;
}
.fc-card.is-default { border-color: var(--cl-teal); box-shadow: 0 0 0 3px rgba(0,196,212,.08) }
.fc-card-h { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; flex-wrap: wrap; margin-bottom: 8px }
.fc-card-l { display: flex; gap: 6px; flex-wrap: wrap }
.fc-tipo-pill {
  font-size: 11px; font-weight: 800; padding: 4px 10px; border-radius: 999px;
  text-transform: uppercase; letter-spacing: .04em;
}
.fc-tipo-pill.empresa { background: #eff6ff; color: #1d4ed8 }
.fc-tipo-pill.consumidor_final { background: #f0fdf4; color: #15803d }
.fc-default-pill {
  font-size: 11px; font-weight: 800; padding: 4px 10px; border-radius: 999px;
  background: var(--cl-teal); color: #fff; text-transform: uppercase; letter-spacing: .04em;
}
.fc-card-actions { display: flex; gap: 6px; flex-wrap: wrap }
.fc-action-btn {
  background: var(--cl-line2); border: 0; color: var(--cl-text);
  font-size: 11px; font-weight: 700; padding: 5px 10px; border-radius: 6px;
  cursor: pointer; font-family: inherit;
}
.fc-action-btn:hover { background: #e2e8f0 }
.fc-action-btn.danger { color: #b91c1c }
.fc-action-btn.danger:hover { background: #fee2e2 }
.fc-card-alias { font-size: 16px; font-weight: 800; color: var(--cl-text); margin-bottom: 6px }
.fc-card-line { font-size: 13px; color: var(--cl-text); margin-bottom: 3px; line-height: 1.5 }
.fc-card-line span { color: var(--cl-muted); font-weight: 700; margin-right: 4px }

.fc-btn-add {
  width: 100%; padding: 14px; background: var(--cl-card); border: 2px dashed var(--cl-line);
  border-radius: 12px; font-size: 14px; font-weight: 800; color: var(--cl-text);
  cursor: pointer; font-family: inherit; transition: border-color .15s, background .15s;
}
.fc-btn-add:hover { border-color: var(--cl-teal); background: rgba(0,212,224,.08); color: var(--cl-teal) }

/* Form */
.fc-form {
  margin-top: 14px; background: var(--cl-card); border: 1.5px solid var(--cl-line);
  border-radius: 14px; padding: 18px;
  display: flex; flex-direction: column; gap: 12px;
}
.fc-form-h { font-size: 17px; font-weight: 900; color: var(--cl-text); margin: 0 0 4px }
.fc-field { display: flex; flex-direction: column; gap: 5px }
.fc-field-l { font-size: 12px; font-weight: 700; color: var(--cl-text) }
.fc-field-l em { color: #ef4444; font-style: normal; margin-left: 2px }
.fc-field-hint { font-size: 11px; color: var(--cl-muted); line-height: 1.4 }
.fc-field input, .fc-field select {
  padding: 10px 12px; border: 1.5px solid var(--cl-line); border-radius: 10px;
  font-size: 14px; font-family: inherit; color: var(--cl-text);
  background: rgba(0,0,0,.25); outline: none; transition: border-color .15s;
}
.fc-field input:focus, .fc-field select:focus { border-color: var(--cl-teal) }
.fc-row-2 { display: grid; grid-template-columns: 1fr; gap: 12px }
@media (min-width: 600px) { .fc-row-2 { grid-template-columns: 1fr 1fr } }

.fc-check { display: flex; align-items: flex-start; gap: 10px; font-size: 13px; color: var(--cl-text); cursor: pointer; padding: 8px 0 }
.fc-check input { width: 18px; height: 18px; accent-color: var(--cl-teal); margin-top: 1px }

.fc-err {
  padding: 10px 12px; background: #fef2f2; border: 1px solid #fca5a5;
  border-radius: 8px; color: #7f1d1d; font-size: 13px;
}

.fc-form-actions { display: flex; gap: 10px; justify-content: flex-end }
.fc-btn-secondary {
  padding: 10px 18px; background: var(--cl-card); border: 1.5px solid var(--cl-line);
  border-radius: 10px; font-size: 14px; font-weight: 700; color: var(--cl-text);
  cursor: pointer; font-family: inherit;
}
.fc-btn-secondary:hover { background: var(--cl-line) }
.fc-btn-primary {
  padding: 10px 20px; background: var(--cl-teal); border: 0; color: #fff;
  border-radius: 10px; font-size: 14px; font-weight: 800; cursor: pointer; font-family: inherit;
}
.fc-btn-primary:disabled { opacity: .4; cursor: not-allowed }

@media (min-width: 900px) {
  .fc-wrap { padding: 28px 32px }
  .fc-h1 { font-size: 28px }
}
`
